var _rect, _rect2, _line, _line2, _line3, _line4, _circle, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 133,
    fill: "#f5f5f5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 18,
    width: 150,
    height: 97,
    fill: "#eaeaea",
    stroke: "#d0d0d0",
    strokeWidth: 1.5,
    rx: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 38,
    x2: 175,
    y2: 38,
    stroke: "#dadada",
    strokeWidth: 0.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 58,
    x2: 175,
    y2: 58,
    stroke: "#dadada",
    strokeWidth: 0.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 78,
    x2: 175,
    y2: 78,
    stroke: "#dadada",
    strokeWidth: 0.8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 98,
    x2: 175,
    y2: 98,
    stroke: "#dadada",
    strokeWidth: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 67,
    r: 14,
    fill: "none",
    stroke: "#bbbbbb",
    strokeWidth: 1.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 60,
    x2: 100,
    y2: 74,
    stroke: "#bbbbbb",
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 93,
    y1: 67,
    x2: 107,
    y2: 67,
    stroke: "#bbbbbb",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric);
export default __webpack_public_path__ + "static/media/generic.a1d90d40f1d6faa3e627c0cf6c504ca2.svg";
export { ForwardRef as ReactComponent };